/*jshint esversion: 6 */
import React from "react";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import Moment from "moment";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Constants from "../../../configurations/constants";
import SettlementsApi from "../../../api/SettlementsApi";
import SettlementsTable from "./settlementsTable";
import Datepicker from "react-datepicker";
import FloatInput from "../../common/floatInput";
import "./../settlement.css";
import ValidatorHelpers from "../../common/validatorhelpers";
import GenerateForm from "../../reports/GenerateForm";
import ReportsApi from "../../../api/ReportsApi";

class SettlementsPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      settlements: [],
      logCode: "",
      statuses: [],
      status: null,
      totalCount: 0,
      loading: false,
      performingAction: false,
      filterParams: {},
      pages: 0,
      openModalFlag: false,
      createFlag: false,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pageNum: 0, //Zero based index,
      selectedSettlementRequest: null,
      createdFromDate: Moment(),
      createdToDate: Moment(),
      disabled: false,
      reportsProgress: [],
      generating: []
    };
    this.onTableChange = this.onTableChange.bind(this);
    this.onRowButtonClick = this.onRowButtonClick.bind(this);
    this.onNewButtonClick = this.onNewButtonClick.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.onDisputeRowClick = this.onDisputeRowClick.bind(this);
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onCreatedFromDateChange = this.onCreatedFromDateChange.bind(this);
    this.onCreatedToDateChange = this.onCreatedToDateChange.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.shouldDisableButton = this.shouldDisableButton.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.generateSettlementReport = this.generateSettlementReport.bind(this);
    this.addToProgressList = this.addToProgressList.bind(this);
    this.getReportStatus = this.getReportStatus.bind(this);
    this.fetchStatus = this.fetchStatus.bind(this);
    this.onDownloadClick = this.onDownloadClick.bind(this);
    this.onRetryClick = this.onRetryClick.bind(this);
    this.clearDownloads = this.clearDownloads.bind(this);
    this.deleteDownload = this.deleteDownload.bind(this);
  }

  deleteDownload(row) {
    const reportsProgress = [...this.state.reportsProgress];
    const index = this.state.reportsProgress.findIndex(
      report => report.id === row.id
    );
    reportsProgress.splice(index, 1);
    this.setState({ reportsProgress });
  }

  clearDownloads() {
    this.setState({
      reportsProgress: []
    });
  }

  onRetryClick(row) {
    const { id } = row;
    ReportsApi.retryReportGeneration("settlements", id)
      .then(response => {
        Toaster.success("Report generation resent");
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.description}`]);
      });
  }

  onDownloadClick(filename) {
    ReportsApi.downloadReport(filename)
      .then(response => {
        window.open(response.config.url, "_blank");
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [` ${error.description}`]);
      });
  }

  getReportStatus(report) {
    this.fetchStatus(report.id)
  }

  fetchStatus(id) {
    const reports = this.state.reportsProgress;
    ReportsApi.getReport(null, id)
      .then(response => {
        const objIndex = reports.findIndex(report => report.id === id);
        const updatedObj = {
          ...reports[objIndex],
          ...response.data
        };

        const reportsProgress = [
          ...reports.slice(0, objIndex),
          updatedObj,
          ...reports.slice(objIndex + 1)
        ];
        this.setState({
          reportsProgress
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          "Error in fetching report status"
        ]);
      });
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    // const idx = parseInt(index, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  onTextInputChange(event) {
    let stateUpdate = {};
    stateUpdate[event.target.id] = event.target.value;
    if (event.target.id === "logCode" && event.target.value) {
      stateUpdate.createdFromDate = null;
      stateUpdate.createdToDate = null;
    } else {
      stateUpdate.createdFromDate = Moment();
      stateUpdate.createdToDate = Moment();
    }
    this.setState(stateUpdate);
  }

  onSearchHandler() {
    //Trigger the call here to be fired
    const params = {};
    if (this.state.createdFromDate) {
      params.startDate = this.state.createdFromDate
        .startOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
    }

    if (this.state.createdToDate) {
      params.endDate = this.state.createdToDate
        .endOf("day")
        .format(`${Constants.DATE_FORMAT_LONG}`);
    }
    params.pageSize = this.state.pageSize;
    params.pageNum = this.state.pageNum;
    this.loadSettlements(params, true);
  }
  componentDidMount() {
    //Get Status
    SettlementsApi.getSettlements()
      .then(response => {
        let statuses = response.data.content.map(status => ({
          label: status,
          value: status
        }));
        this.setState({
          statuses
        });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_SETTLEMENT_REQUEST_STATUSES}`
        ]);
      });
  }

  onNewButtonClick(evt) {
    this.setState({ openModalFlag: true, createFlag: true });
  }
  handleFilterChange(evt) {
    this.setState({ status: evt }, () => this.reloadSettlements());
  }

  onDisputeRowClick(index) {}

  onCreatedFromDateChange(date, event) {
    if (event === undefined || event === null) {
      this.setState({ createdFromDate: null });
      return;
    }
    this.setState({ createdFromDate: date }, this.shouldDisableButton);
  }
  onCreatedToDateChange(date, event) {
    if (event === undefined || event === null) {
      this.setState({ createdToDate: null });
      return;
    }
    this.setState({ createdToDate: date }, this.shouldDisableButton);
  }

  generateSettlementReport(reportType) {
    let generating = this.state.generating.slice();
    generating[reportType] = true;
    this.setState({ generating });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.reportType = reportType;
      SettlementsApi.generateSettlementReport(params)
        .then(response => {
          Toaster.success("Settlement report request successful!");
          this.setState({ generating: [] });
          response && this.addToProgressList(response.data);
        })
        .catch(error => {
          console.log(error);
          Util.errorMessageToast(Toaster, error.data, [
            ` ${Messages.ERROR_GENERATING_SETTLEMENT_REPORTS}`
          ]);
          this.setState({ generating: [] });
        });
    }
  }

  shouldDisableButton(e) {
    //Check that it's Set and Not Empty
    if (
      ValidatorHelpers.isEmpty(this.state.createdFromDate) ||
      ValidatorHelpers.isEmpty(this.state.createdToDate)
    ) {
      this.setState({
        disabled: true
      });
    } else {
      this.setState({
        disabled: false
      });
    }
  }

  addToProgressList(reportObject) {
    this.setState({
      reportsProgress: [...this.state.reportsProgress, reportObject]
    });
  }

  render() {
    const {
      settlements,
      generating,
      filterParams,
      reportsProgress
    } = this.state;
    let isFiltered;
    if (filterParams) {
      const { pageSize, pageNum, ...hasFilter } = filterParams;
      isFiltered =
        Object.keys(hasFilter).length !== 0 && hasFilter.constructor === Object;
    }
    const showGenerateForm = isFiltered && settlements && settlements.length;
    return (
      <div>
        <form
          onSubmit={e => {
            this.onSearchHandler();
            e.preventDefault();
            return false;
          }}
        >
          <div id="page-breadcrumb" className="breadcrumb-container">
            <Breadcrumbs
              separator={Constants.BREADCRUMB_SEPARATOR}
              routes={this.props.routes}
              params={this.props.params}
            />
          </div>
          <PageTitle title="Settlements" />

          <div className="mini-filter">
            <div className="filter-select" style={{ width: "100%" }}>
              <div className="">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="input-control-label">Log Code</label>
                      <FloatInput
                        id="logCode"
                        value={this.state.logCode}
                        onChange={this.onTextInputChange}
                        placeholder="Log Code"
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="input-control-label">From</label>
                      <Datepicker
                        onChange={this.onCreatedFromDateChange}
                        onSelect={this.onCreatedFromDateChange}
                        className="form-control float_input"
                        id="createdFromDate"
                        placeholderText="From Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        readOnly
                        disabled={this.state.logCode}
                        dropdownMode="select"
                        maxDate={
                          this.state.createdToDate
                            ? this.state.createdToDate
                            : Moment()
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={
                          !this.state.logCode
                            ? this.state.createdFromDate
                            : null
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label className="input-control-label">To</label>
                      <Datepicker
                        onChange={this.onCreatedToDateChange}
                        onSelect={this.onCreatedToDateChange}
                        className="form-control float_input"
                        id="createdToDate"
                        placeholderText="To Date"
                        disabledKeyboardNavigation
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        readOnly
                        dropdownMode="select"
                        disabled={this.state.logCode}
                        minDate={
                          this.state.createdFromDate
                            ? this.state.createdFromDate.clone().add(0, "days")
                            : Moment()
                                .clone()
                                .add(0, "days")
                        }
                        dateFormat={Constants.DATE_FORMAT}
                        selected={
                          !this.state.logCode ? this.state.createdToDate : null
                        }
                      />
                    </div>
                  </div>
                  <div className=" col-md-2">
                    <div className="form-group">
                      <label
                        className="input-control-label"
                        style={{ display: "block" }}
                      >
                        &nbsp;
                      </label>
                      <button
                        id="searchButton"
                        className="btn btn-block btn-primary"
                        type="submit"
                        disabled={this.state.disabled}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <GenerateForm
                  data={settlements}
                  generating={generating}
                  progressList={reportsProgress}
                  showForm={showGenerateForm}
                  generate={this.generateSettlementReport}
                  retry={this.onRetryClick}
                  deleteDownload={this.deleteDownload}
                  download={this.onDownloadClick}
                  clearDownloads={this.clearDownloads}
                  getReportStatus={this.getReportStatus}
                />
              </div>
            </div>
          </div>
        </form>
        <SettlementsTable
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          disableActions={this.state.performingAction}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          settlements={this.state.settlements}
          paginatedCallBack={this.paginateid}
          manual
        />
      </div>
    );
  }

  handleCloseModal(event, reloadDataFlag) {
    this.setState({ settlements: null, openModalFlag: false });
    if (reloadDataFlag) {
      this.reloadSettlements();
    }
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.loadSettlements(params);
    }
  }

  loadSettlements(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true, settlements: [] };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    if (this.state.filterParam) {
      params.pageSize = params.pageSize || this.state.pageSize;
      params.pageNum = params.pageNum || this.state.pageNum + 1;
    }

    let status = this.state.status;
    let logCode = this.state.logCode;

    if (logCode) {
      params.logCode = logCode;
    }
    if (status && status.value) {
      params.status = status.value;
    }
    SettlementsApi.getSettlements(params)
      .then(response => {
        let data = response.data.content;
        data = data.map(d => {
          return {
            ...d,
            settlementDate: Util.toUserLocalTime(d.settlementDate)
          };
        });
        let totalCount = response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Settlements");
        else {
          //add click handler to each data object
          data = data.map(val => {
            val.clickHandler = this.onRowButtonClick;
            return val;
          });
        }
        this.setState({
          settlements: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_SETTLEMENT_REQUESTS}`
        ]);
        this.setState({ loading: false });
      });
  }

  onRowButtonClick(index, action) {
    let selectedSettlement = this.state.settlements[index];
    if (action !== Constants.SETTLEMENT_REQUEST_ACTION_CANCEL) {
      this.processRequest(selectedSettlement.requestReference, { action });
    } else {
      this.setState({
        selectedSettlement,
        openModalFlag: true,
        createFlag: false
      });
    }
  }

  reloadSettlements() {
    this.setState({ settlementRequests: [] });
    this.loadSettlements({ pageSize: this.state.pageSize });
  }

  processRequest(reference, data) {
    this.setState({ performingAction: true });
    SettlementsApi.processSettlementRequest(reference, data)
      .then(response => {
        let message = "";

        if (data.action === Constants.SETTLEMENT_REQUEST_ACTION_PROCESS)
          message = Messages.SUCCESS_SETTLEMENT_REQUEST_PROCESSED;
        if (data.action === Constants.SETTLEMENT_REQUEST_ACTION_MAP)
          message = Messages.SUCCESS_SETTLEMENT_REQUEST_MAPPED;
        if (data.action === Constants.SETTLEMENT_REQUEST_ACTION_CANCEL)
          message = Messages.SUCCESS_SETTLEMENT_REQUEST_CANCELED;

        Toaster.success(`${message}`, `${reference}`);
        this.reloadSettlements();
        this.setState({ performingAction: false });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [` ${error.statusText}`]);
        this.setState({ performingAction: false });
      });
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(SettlementsPage, [Permissions.VIEW_SETTLEMENT])
);



// WEBPACK FOOTER //
// ./src/components/settlement/settlements/settlementPage.js